import React, { useEffect, useState } from 'react';
import { simpleFetch, getToken } from "../../../utils/helpsers";
import CircularProgress from '@mui/material/CircularProgress';
import DefinitionCard from "./DefinitionCard";
import { addSourceYear, renderSources } from "../../../utils/sourceCitation";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { DefinitionCardSelectorStyles } from "./DefinitionCardSelector.styles";
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: '#fff',
    border: 'none',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#000',
  }),
  input: (provided) => ({
    ...provided,
    color: '#000',
  })
}

export default function DefinitionsCardSelector(props) {
  const { sourceURL } = props;
  const [variablesGroup, setVariablesGroup] = useState();
  const [currentCard, setCurrentCard] = useState();
  const [showCard, setShowCard] = useState(false);
  const [autocompleteValue, setAutocompleteValue] = useState(null);

  const displayCard = (item) => {
    setCurrentCard(DefinitionCard(item));
    setShowCard(true);
  }

  const resetAutocomplete = () => {
    setAutocompleteValue(null);
  };

  useEffect(() => {
    simpleFetch(sourceURL, getToken())
      .then(response => {
        const data = {};
        response.map(elem => {
          let label = elem.label.substring(elem.label.indexOf('/') + 1);
          if (!(label in data)) {
            data[label] = {
              value: elem.value,
              title: label,
              label: label,
              subtitle: elem.domain,
              description: elem.description,
              rows: [
                ['Data Type', elem.var_type ? elem.var_type : 'No data Type available.'],
                ['Authority', elem.author ? elem.author : 'No source available.'],
                ['Last Update', elem.available_years ? elem.available_years[0] : 0],
                ['Years Available', elem.available_years ? elem.available_years : []],
                [elem.dwh_table === 'calculated' ? 'Formula' : 'Notes', elem.notes ? elem.notes : 'No note available.'],
                ['Source', elem.source ? elem.source.apa_ref ? elem.source.apa_ref : 'No APA reference available.' : 'No source available.'],
              ],
              note: elem.note,
              sources: {}
            }
          }
          // Which file each year came from -- folded into the Source row below.
          addSourceYear(data[label].sources, elem);

          for (let i = 0; i < data[label].rows[3][1].length; i++) {
            if (data[label].rows[3][1][i] === elem.file_year) {
              data[label].rows[3][1][i] = <span> <a href={elem.source.r_page}>{elem.file_year}</a>{i === data[label].rows[3][1].length - 1 ? '' : ','}</span>;
            }
          }


          return data;
        })
        // Source row: one line per source, newest first, each with its own
        // years -- the view's apa_ref pastes the whole year list next to one
        // source name, wrong once a variable has moved between files.
        Object.values(data).forEach((entry) => {
          const cited = renderSources(entry.sources);
          if (cited) entry.rows[5][1] = cited;
        });
        return data;
      })
      .then(data => setVariablesGroup(data))
      .catch(error => alert(error.response.data.details));
  }, [sourceURL]);

  return (
    !variablesGroup ?
      <CircularProgress height={30} width={30} /> :
      <Box sx={DefinitionCardSelectorStyles}>
        <div className={'data-filters__item filter-district'}>
            <Autocomplete
                id="glossary-terms"
                className={"definitions__select form-select"}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                options={Object.values(variablesGroup)}
                fullWidth={true}
                value={autocompleteValue}
                onChange={(event, newValue) => {
                    if(newValue) return displayCard(newValue)
                    resetAutocomplete();
                }}
                renderInput={(params) =>
                    <TextField {...params} label={'Lookup Definitions:'} />
                }
                styles={customStyles}
            />
          {showCard && (
            <div>
              <CloseIcon className={"close_icon"} onClick={() => setShowCard(false)} />
              {currentCard}
            </div>
          )}
        </div>
      </Box>
  );

}
